module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content"
  }, [_c('md-whiteframe', {
    staticClass: "main-header topnav",
    attrs: {
      "md-tag": "md-toolbar",
      "md-elevation": "1"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button nav-trigger",
    on: {
      "click": _vm.toggleSidenav
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.pageTitle))]), _vm._v(" "), _c('h2', {
    staticClass: "md-title",
    staticStyle: {
      "flex": "1"
    },
    attrs: {
      "align": "center",
      "id": "title"
    }
  }, [_vm._v(" \n      " + _vm._s(_vm.softwareTitle) + "  \n    ")]), _vm._v(" "), _c('md-menu', {
    ref: "langCard",
    attrs: {
      "md-size": "3"
    }
  }, [_c('md-button', {
    staticClass: "md-button md-sqlang",
    attrs: {
      "id": "langButton",
      "md-menu-trigger": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.local) + "\n        "), _c('md-icon', [_vm._v("language")])], 1), _vm._v(" "), _c('md-menu-content', {
    staticClass: "langMenu"
  }, [_c('md-menu-item', {
    attrs: {
      "md-active": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.setLocale('es')
      }
    }
  }, [_c('md-radio', {
    attrs: {
      "id": "my-test1",
      "name": "idiomaGroup",
      "md-value": "es"
    },
    model: {
      value: (_vm.local),
      callback: function($$v) {
        _vm.local = $$v
      },
      expression: "local"
    }
  }, [_vm._v(_vm._s(_vm._f("translate")('global.~ESPANOL~')))])], 1), _vm._v(" "), _c('md-menu-item', {
    nativeOn: {
      "click": function($event) {
        _vm.setLocale('en')
      }
    }
  }, [_c('md-radio', {
    attrs: {
      "id": "my-test2",
      "name": "idiomaGroup",
      "md-value": "en"
    },
    model: {
      value: (_vm.local),
      callback: function($$v) {
        _vm.local = $$v
      },
      expression: "local"
    }
  }, [_vm._v(_vm._s(_vm._f("translate")('global.~INGLES~')))])], 1), _vm._v(" "), _c('md-menu-item', {
    nativeOn: {
      "click": function($event) {
        _vm.setLocale('pt')
      }
    }
  }, [_c('md-radio', {
    attrs: {
      "id": "my-test3",
      "name": "idiomaGroup",
      "md-value": "pt"
    },
    model: {
      value: (_vm.local),
      callback: function($$v) {
        _vm.local = $$v
      },
      expression: "local"
    }
  }, [_vm._v(_vm._s(_vm._f("translate")('global.~PORTUGUES~')))])], 1)], 1)], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button help-button",
    nativeOn: {
      "click": function($event) {
        return _vm.activeHelp($event)
      }
    }
  }, [_c('md-icon', {
    class: {
      'custom-color-active': _vm.isActiveHelp, 'custom-color': !_vm.isActiveHelp
    }
  }, [_vm._v("live_help")]), _vm._v(" "), (_vm.isActiveHelp) ? _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom"
    }
  }, [_vm._v("\n        " + _vm._s(_vm._f("translate")('global.~DESACTIVAR~')) + "\n      ")]) : _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom"
    }
  }, [_vm._v("\n        " + _vm._s(_vm._f("translate")('global.~ACTIVAR~')) + "\n      ")])], 1)], 1), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('main-footer', {
    attrs: {
      "name": _vm.softwareTitle
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b2b1e46","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page-content.vue
// module id = 1015
// module chunks = 14